const initialState = {
  messages: null,
};

const errors = (state = initialState, { payload, error }) => {
  if (error && payload.global && payload.errors) {
    return {
      ...state,
      ...payload.errors,
    };
  }
  return initialState;
};

export default errors;



// WEBPACK FOOTER //
// ./client/app/reducers/error.js